import React, { ReactElement } from 'react';
import sizeMe, { SizeMeProps } from 'react-sizeme';

import gtmIds, { dataId } from 'adapter/in/dashboards/config/gtm';
import { StyledGrabbale } from 'adapter/in/dashboards/pages/Widget/Wrapper/style';
import WidgetActionsMenuContainer from 'adapter/in/dashboards/containers/Widget/WidgetActionsMenu';
import { WidgetType } from 'domain/entity/widget';
import Branding from 'domain/entity/branding';
import { ConstraintsPerLayoutElement, LayoutType } from 'domain/entity/layout';
import { KeyAndNamePair } from 'adapter/in/common/context/currentWidgetConfiguration';

import SmallAlertTooltip from 'adapter/in/dashboards/components/SmallAlertTooltip';
import { AnalysisActionsMenuContainer } from 'adapter/in/dashboards/containers/Widget/AnalysisActionsMenu/AnalysisActionsMenu';

type WidgetWrapperProps = {
    isEditingLayout: boolean;
    isEditEnabled: boolean;
    hasWidgetDataError: boolean;
    WidgetBuilder: (
        width: number,
        height: number,
        layoutType?: LayoutType,
        editable?: boolean,
        sizeIssue?: ConstraintsPerLayoutElement
    ) => ReactElement;
    dashboardId: string;
    widgetId: string;
    widgetType: WidgetType;
    isSelectedWidget: boolean;
    branding: Branding;
    layoutType: LayoutType;
    newPreset: KeyAndNamePair;
    newFeature: KeyAndNamePair;
    sizeIssue?: ConstraintsPerLayoutElement;
    alertTooltip?: string;
};

const sizeMeHOC = sizeMe({
    monitorWidth: true,
    monitorHeight: true,
    refreshRate: 16,
});

const WidgetWrapper = (props: WidgetWrapperProps & SizeMeProps): ReactElement => {
    const {
        WidgetBuilder,
        size,
        isEditingLayout,
        isEditEnabled,
        dashboardId,
        widgetId,
        widgetType,
        isSelectedWidget,
        branding,
        layoutType,
        newPreset,
        newFeature,
        hasWidgetDataError,
        sizeIssue,
        alertTooltip,
    } = props;

    return (
        <StyledGrabbale
            data-testid='widget-wrapper'
            data-id={`${dataId}.${gtmIds.widget.notEditable}`}
            editable={isEditingLayout}
            isEditEnabled={isEditEnabled}
            isWidgetSelected={isSelectedWidget}
            branding={branding}
        >
            {alertTooltip && <SmallAlertTooltip tooltipMessage={alertTooltip} />}
            {isEditEnabled && !isEditingLayout && widgetType !== WidgetType.ANALYSIS && (
                <WidgetActionsMenuContainer
                    showOptions={!hasWidgetDataError}
                    newPreset={newPreset}
                    newFeature={newFeature}
                    dashboardId={dashboardId}
                    widgetId={widgetId}
                    widgetType={widgetType}
                />
            )}
            {isEditEnabled && !isEditingLayout && widgetType === WidgetType.ANALYSIS && (
                <AnalysisActionsMenuContainer dashboardId={dashboardId} analysisId={widgetId} />
            )}
            {WidgetBuilder(size.width!, size.height!, layoutType, isEditingLayout, sizeIssue)}
        </StyledGrabbale>
    );
};

export default sizeMeHOC(WidgetWrapper);
